import React from 'react';
import PropTypes from 'prop-types';
import Typography from "@material-ui/core/Typography";
import withStyles from "@material-ui/core/styles/withStyles";

const styles = theme => ({
    root: {
        color: theme.palette.common.white,
        marginBottom: theme.spacing(3),
        display: 'flex',
        justifyContent: 'space-between'
    }
});

const AppHeader = ({classes, title, provider, ...props}) => {
    return (
        <div className={classes.root}>
            <Typography variant='h2' color='inherit'>
                {title}
            </Typography>
            <Typography variant='body1' align='right'>
                Indoor data provided by<br/>
                {provider}
            </Typography>
        </div>
    );
};

AppHeader.propTypes = {
    title: PropTypes.string.isRequired,
    provider: PropTypes.string.isRequired,
};

export default withStyles(styles)(AppHeader);
